<template>
  <div class="new-guide-step-2">
    <form-item label="行为事件">
      <div class="action-event-cont">
        <div v-for="(localRetentionEventItem, index) in localRetentionEvents" :key="index" class="action-event-item">
          <div class="action-event-label-cont">
            <span class="action-event-show-label">{{ getCharCode(index) }}</span>
            <icon
              name="delete"
              class="remove-btn"
              @click="handleDeleteActionEvent(index)"
              v-if="localRetentionEvents.length > 1"
            />
          </div>
          <div class="action-event-source-cont">
            <div class="action-event-source-label">起始行为</div>
            <div class="action-event-source">
              <div class="action-event" :class="{ 'pb-0': localRetentionEventItem.firstEvent.conditionModels.length }">
                <div class="action-event-row">
                  <t-select
                    v-model="localRetentionEventItem.firstEvent.eventName"
                    placeholder="请选择"
                    class="action-event-select"
                    @change="handleEventNameChange(index, 'firstEvent')"
                    filterable
                  >
                    <t-option
                      v-for="item in eventList"
                      :key="item.id"
                      :label="item.eventShowName"
                      :value="item.eventName"
                    ></t-option>
                  </t-select>
                  <t-button @click="handleAddFilterItem(index, 'firstEvent')" class="btn-filter" variant="outline">
                    <icon name="add" slot="icon"></icon>
                    筛选项
                  </t-button>
                </div>
                <div class="ref-column-row" v-if="isLinkAttr">
                  <property-selector
                    :show-total="false"
                    :condition-property-options="conditionPropertyOptions"
                    @change="handleColumnChange(index, 'firstEvent')"
                    v-model="localRetentionEventItem.firstEvent.relationDTO.column"
                    class="ref-column-select"
                    :class="{ 'red-tips': !equalColumnJavaType(index) }"
                  ></property-selector>
                </div>
              </div>
              <div class="filter" v-if="localRetentionEventItem.firstEvent.conditionModels.length">
                <ConditionFilter
                  :filter-type.sync="localRetentionEventItem.firstEvent.connectors"
                  :filter-list="localRetentionEventItem.firstEvent.conditionModels"
                  :condition-operator-options="conditionOperatorOptions"
                  :condition-property-options="conditionPropertyOptions"
                />
              </div>
            </div>
          </div>
          <div class="action-event-target-cont">
            <div class="action-event-target-label">后续行为</div>
            <div class="action-event-target">
              <div class="action-event" :class="{ 'pb-0': localRetentionEventItem.followEvent.conditionModels.length }">
                <div class="action-event-row">
                  <t-select
                    v-model="localRetentionEventItem.followEvent.eventName"
                    placeholder="请选择"
                    class="action-event-select"
                    @change="handleEventNameChange(index, 'followEvent')"
                    filterable
                  >
                    <t-option
                      v-for="item in eventList"
                      :key="item.id"
                      :label="item.eventShowName"
                      :value="item.eventName"
                    ></t-option>
                  </t-select>
                  <t-button @click="handleAddFilterItem(index, 'followEvent')" class="btn-filter" variant="outline">
                    <icon name="add" slot="icon"></icon>
                    筛选项
                  </t-button>
                </div>
                <div class="ref-column-row" v-if="isLinkAttr">
                  <property-selector
                    :show-total="false"
                    :condition-property-options="conditionPropertyOptions"
                    @change="handleColumnChange(index, 'followEvent')"
                    v-model="localRetentionEventItem.followEvent.relationDTO.column"
                    class="ref-column-select"
                    :class="{ 'red-tips': !equalColumnJavaType(index) }"
                  ></property-selector>
                </div>
              </div>
              <div class="filter" v-if="localRetentionEventItem.followEvent.conditionModels.length">
                <ConditionFilter
                  :filter-type.sync="localRetentionEventItem.followEvent.connectors"
                  :filter-list="localRetentionEventItem.followEvent.conditionModels"
                  :condition-operator-options="conditionOperatorOptions"
                  :condition-property-options="conditionPropertyOptions"
                />
              </div>
            </div>
          </div>
        </div>
        <t-button @click="handleAddActionEvent" class="btn-filter" variant="outline">
          <icon name="add" slot="icon"></icon>
          新增对照组
        </t-button>
      </div>
    </form-item>
  </div>
</template>

<script>
import lodash from 'lodash';
import FormItem from './form-item.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';
import PropertySelector from '@/components/analysis/property-selector.vue';

export default {
  name: 'RetentionEvent',
  components: {
    PropertySelector,
    FormItem,
    ConditionFilter,
  },
  model: {
    prop: 'retentionEvents',
    event: 'change',
  },
  props: {
    retentionEvents: {
      type: Array,
      default: () => [],
    },
    isLinkAttr: {
      type: Boolean,
    },
    eventList: {
      type: Array,
      default: () => [],
    },
    conditionPropertyOptions: {
      type: Array,
      default: () => [],
    },
    conditionOperatorOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localRetentionEvents: lodash.cloneDeep(this.retentionEvents),
    };
  },
  computed: {
    eventNameAndShowNameMap() {
      return this.eventList.reduce((total, item) => {
        total[item.eventName] = item.eventShowName;
        return total;
      }, {});
    },
    columnNameAndShowNameMap() {
      return this.conditionPropertyOptions.reduce((total, item) => {
        total[item.propertyName] = item.propertyDesc;
        return total;
      }, {});
    },
    columnNameAndJavaTypeMap() {
      return this.conditionPropertyOptions.reduce((total, item) => {
        total[item.propertyName] = item.propertyDataType;
        return total;
      }, {});
    },
  },
  watch: {
    retentionEvents: {
      handler() {
        if (JSON.stringify(this.retentionEvents) !== JSON.stringify(this.localRetentionEvents)) {
          this.localRetentionEvents = lodash.cloneDeep(this.retentionEvents);
        }
      },
      deep: true,
    },
    localRetentionEvents: {
      handler() {
        this.$emit('change', lodash.cloneDeep(this.localRetentionEvents));
      },
      deep: true,
    },
    isLinkAttr() {
      if (!this.isLinkAttr) {
        this.localRetentionEvents.forEach(item => {
          item.firstEvent.relationDTO = { column: '', chineseName: '' };
          item.followEvent.relationDTO = { column: '', chineseName: '' };
        });
      }
    },
  },
  methods: {
    getCharCode(index) {
      const showLabel = String.fromCharCode(65 + parseInt(index, 10));
      this.localRetentionEvents[index].showLabel = showLabel;
      return showLabel;
    },
    handleEventNameChange(index, type) {
      const { eventName } = this.localRetentionEvents[index][type];
      const eventChineseName = this.eventNameAndShowNameMap[eventName];
      this.localRetentionEvents[index][type].eventChineseName = eventChineseName || '';
    },
    handleColumnChange(index, type) {
      const { relationDTO } = this.localRetentionEvents[index][type];
      const columnChineseName = this.columnNameAndShowNameMap[relationDTO.column];
      this.localRetentionEvents[index][type].relationDTO.chineseName = columnChineseName || '';

      const { firstEvent, followEvent } = this.localRetentionEvents[index];
      if (!firstEvent.relationDTO.column || !followEvent.relationDTO.column) {
        return;
      }
      if (
        this.columnNameAndJavaTypeMap[firstEvent.relationDTO.column] !==
        this.columnNameAndJavaTypeMap[followEvent.relationDTO.column]
      ) {
        this.$message.warning('关联属性值类型不一致，请修改');
      }
    },
    handleAddFilterItem(index, type) {
      if (this.localRetentionEvents[index][type].conditionModels.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      this.localRetentionEvents[index][type].conditionModels.push({
        column: '',
        conditionOperator: '',
        value: undefined,
      });
    },
    handleAddActionEvent() {
      if (this.localRetentionEvents.length >= 5) {
        this.$message.warning('最多添加5个行为事件');
        return;
      }
      this.localRetentionEvents.push({
        showLabel: '',
        firstEvent: {
          eventName: '',
          eventChineseName: '',
          relationDTO: {
            column: '',
            chineseName: '',
          },
          connectors: 'and',
          conditionModels: [],
        },
        followEvent: {
          eventName: '',
          eventChineseName: '',
          relationDTO: {
            column: '',
            chineseName: '',
          },
          connectors: 'and',
          conditionModels: [],
        },
      });
    },
    handleDeleteActionEvent(index) {
      this.localRetentionEvents.splice(index, 1);
    },
    equalColumnJavaType(index) {
      const { firstEvent, followEvent } = this.localRetentionEvents[index];
      if (!firstEvent.relationDTO.column || !followEvent.relationDTO.column) {
        return true;
      }
      return (
        this.columnNameAndJavaTypeMap[firstEvent.relationDTO.column] ===
        this.columnNameAndJavaTypeMap[followEvent.relationDTO.column]
      );
    },
  },
};
</script>

<style lang="less">
.modal {
  border-radius: 4px;

  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
<style lang="less" scoped>
@import './retention-event';
</style>
